export default __webpack_public_path__ + "static/media/o-nama.975586bd.jpg";